<form class="cadastros-edit" ng-submit="edit.saveItem($event)" name="itemEditForm">
  <span ng-if="!edit.isShowing()">
    <h3 ng-show="!edit.item">Novo item</h3>
    <h3 ng-show="edit.item">Editando <i>{{edit.item.descricao}}</i></h3>
  </span>
  <div class="row">
    <!-- Descricao -->
    <div class="col-xs-6">
      <div class="form-group">
        <label for="description" class="control-label">Descrição</label>
        <input type="text" ng-model="edit.editItem.descricao" name="description" id="description" required class="form-control" ng-disabled="edit.isShowing()" maxlength=50>
        <p ng-if="edit.editItem.descricao.length == 50">
          <b>O número máximo de caracteres permitidos foi atingido.</b>
        </p>
      </div>
    </div>
    <!-- Grupo de insumos -->
    <div class="col-xs-6">
      <div class="form-group">
        <label for="grupo" class="control-label">Grupo de insumos</label>
        <ui-select required name="grupo" id="grupo" ng-model="edit.editItem.grupo" ng-disabled="edit.isShowing()">
          <ui-select-match>{{$select.selected.descricao | capitalize}}</ui-select-match>
          <ui-select-choices repeat="group in edit.groups | filter: $select.search">
            <span ng-bind-html="group.descricao | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>
  </div>

  <div class="row">
    <!-- Unidade -->
    <div class="col-xs-4">
      <div class="form-group">
        <label for="unit" class="control-label">Unidade</label>
        <ui-select ng-disabled="edit.editItem.id" required name="unit" id="unit" ng-model="edit.editItem.unidade" ng-disabled="edit.isShowing()">
          <ui-select-match>{{($select.selected.descricao_padrao || $select.selected.descricao) | capitalize}}</ui-select-match>
          <ui-select-choices repeat="unit in edit.units | filter: $select.search">
            <span ng-bind-html="(unit.descricao_padrao || unit.descricao) | capitalize | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>

    <!-- Carência -->
    <div class="col-xs-4">
      <div class="form-group">
        <label for="carencia_residual_dias" class="control-label">Prazo de Carência em Dias</label>
        <input type="number" ng-model="edit.editItem.carencia_residual_dias" name="carencia_residual_dias" id="carencia_residual_dias" class="form-control" ng-disabled="edit.isShowing()">
      </div>
    </div>

    <div class="col-xs-4">
      <div class="form-group">
        <!-- Indicativo se é uma semente ou não -->
        <div class="checkbox">
          <label>
            <input type="checkbox" ng-model="edit.editItem.semente" ng-disabled="edit.isShowing()"> É uma semente?
          </label>
        </div>
        <!-- Possui Tratamento -->
        <div class="checkbox" ng-if="edit.editItem.semente">
          <label>
            <input type="checkbox" ng-model="edit.editItem.possui_tratamento" ng-disabled="edit.isShowing()"> Possui tratamento
          </label>
        </div>
      </div>
    </div>
  </div>

  <!-- Bloco de semente -->
  <div ng-if="edit.editItem.semente">
    <div class="row">
      <!-- Produto -->
      <div class="col-xs-6">
        <div class="form-group">
          <label for="product" class="control-label">Produto</label>
          <ui-select ng-required="edit.editItem.semente" name="product" id="product" ng-model="edit.editItem.produto" ng-disabled="edit.isShowing()">
            <ui-select-match>{{$select.selected.descricao}}</ui-select-match>
            <ui-select-choices repeat="product in edit.products | filter: $select.search">
              <span ng-bind-html="product.descricao | highlight: $select.search"></span>
            </ui-select-choices>
          </ui-select>
        </div>
      </div>

      <!-- Atividade -->
      <div class="col-xs-6">
        <div class="form-group">
          <label for="atividade" class="control-label">Atividade</label>
          <ui-select ng-required="edit.editItem.semente" name="atividade" id="atividade" ng-model="edit.editItem.atividade" ng-disabled="edit.isShowing()">
            <ui-select-match>{{$select.selected.descricao | capitalize}}</ui-select-match>
            <ui-select-choices repeat="atividade in edit.atividades | filter: $select.search">
              <span ng-bind-html="atividade.descricao | highlight: $select.search"></span>
            </ui-select-choices>
          </ui-select>
        </div>
      </div>
    </div>

    <div class="row" ng-if="edit.editItem.semente">
      <div class="col-xs-12 itens-estoque">
        <div class="form-group">
          <label for="produtos" class="control-label">Semente não tratada de origem</label>
          <ui-select ng-required="edit.editItem.semente && edit.editItem.possui_tratamento" ng-model="edit.editItem.produto_origem" theme="bootstrap" id="produtos" name="produtos" ng-disabled="!edit.editItem.possui_tratamento">
            <ui-select-match allow-clear="edit.editItem.possui_tratamento" placeholder="Pesquisar produto">{{$select.selected.descricao}}</ui-select-match>
            <ui-select-choices repeat="produto in edit.itensEstoque" refresh="edit.searchItensEstoque($select)" refresh-delay="300">
              <div ng-bind-html="produto.descricao | highlight: $select.search"></div>
            </ui-select-choices>
          </ui-select>
          <div ng-show="edit.editItem.possui_tratamento">
            <small class="help-block" ng-show="edit.searchItensTerm.length < 3 && !loadingProdutos && !edit.itensEstoque && !edit.editItem.produto_origem">
              Informe pelo menos 3 caracteres
            </small>
            <span class="input-group-addon no-border no-background" ng-show="edit.loadingItensEstoque">
              <i class="fa fa-spinner fa-spin"></i>
            </span>
            <span class="input-group-addon no-border no-background" ng-show="!loadingProdutos && edit.itensEstoque.length === 0">
              Não encontrado
            </span>
          </div>
        </div>
        <button type="button" class="btn btn-white" title="Ver todos os produtos" ng-click="edit.openItensEstoqueModal()" ng-disabled="!edit.editItem.possui_tratamento">
          <i class="fa fa-external-link"></i>
        </button>
      </div>
    </div>
  </div>

  <hr>
  <div class="row" ng-if="!edit.isShowing()">
    <div class="col-xs-6">
      <button type="button" class="btn btn-danger" ng-click="edit.deleteItem()" ng-disabled="edit.loading" ng-if="edit.item">
        Apagar
        <i class="fa fa-trash"></i>
      </button>
    </div>
    <div class="col-xs-6 text-right">
      <button type="button" class="btn btn-white" ng-click="edit.cancel()" ng-disabled="edit.loading">Cancelar</button>
      <button type="submit" class="btn btn-success" ng-disabled="itemEditForm.$invalid || edit.loading">
        <span ng-show="!edit.loading">
          Salvar
          <i class="fa fa-save"></i>
        </span>
        <i class="fa fa-spinner fa-pulse fa-fw" ng-show="edit.loading"></i>
      </button>
    </div>
  </div>
</form>
